// extracted by mini-css-extract-plugin
export default {"card":"Card_card__fZhbR","capa":"Card_capa__Zg8Hz","icon":"Card_icon__aqxfJ"};